import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'db-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() icon: string;

  constructor() { }

  ngOnInit() {
  }

}
